/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { Liquidation } from "../Liquidation";

export class Liquidation__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _addressProvider: string,
    _optionVault: string,
    _amm: string,
    _usdc: string,
    _weth: string,
    overrides?: Overrides
  ): Promise<Liquidation> {
    return super.deploy(
      _addressProvider,
      _optionVault,
      _amm,
      _usdc,
      _weth,
      overrides || {}
    ) as Promise<Liquidation>;
  }
  getDeployTransaction(
    _addressProvider: string,
    _optionVault: string,
    _amm: string,
    _usdc: string,
    _weth: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _addressProvider,
      _optionVault,
      _amm,
      _usdc,
      _weth,
      overrides || {}
    );
  }
  attach(address: string): Liquidation {
    return super.attach(address) as Liquidation;
  }
  connect(signer: Signer): Liquidation__factory {
    return super.connect(signer) as Liquidation__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Liquidation {
    return new Contract(address, _abi, signerOrProvider) as Liquidation;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ILendingPoolAddressesProvider",
        name: "_addressProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_optionVault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_usdc",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ADDRESSES_PROVIDER",
    outputs: [
      {
        internalType: "contract ILendingPoolAddressesProvider",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LENDING_POOL",
    outputs: [
      {
        internalType: "contract ILendingPool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "premiums",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "initiator",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "params",
        type: "bytes",
      },
    ],
    name: "executeOperation",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_accountId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_seriesId",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "_liqAmount",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "_maxFee",
        type: "uint256",
      },
    ],
    name: "liquidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
